module.exports = __webpack_public_path__ + "img/s.720b8e59.png";